/* Collection-card swatch hover.

   Hovering a colour swatch swaps the card image to that variant, and restores
   the original on leave. Recovered from the pre-migration theme, with one fix:
   the original cleared `srcset` to avoid stale candidates but never put it
   back, so a card permanently lost its responsive sources after one hover. */
(() => {
  if (window.__swatchHoverInit) return;
  window.__swatchHoverInit = true;

  const findCardImage = (root) =>
    root.querySelector('.card-gallery img, product-card img, .product-card img, img');

  const cardOf = (el) => el.closest('li, .resource-list__item, product-card');

  document.addEventListener(
    'mouseover',
    (event) => {
      const swatch = event.target.closest('.card-swatches__swatch');
      if (!swatch) return;

      const card = cardOf(swatch);
      if (!card) return;

      const img = findCardImage(card);
      const url = swatch.getAttribute('data-image-url');
      if (!img || !url) return;

      // Remember the original once, including srcset and sizes.
      if (img.dataset.swatchOriginalSrc == null) {
        img.dataset.swatchOriginalSrc = img.getAttribute('src') || '';
        img.dataset.swatchOriginalSrcset = img.getAttribute('srcset') || '';
        img.dataset.swatchOriginalSizes = img.getAttribute('sizes') || '';
      }

      if (img.getAttribute('src') !== url) {
        // srcset would otherwise win over the swapped src
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      const swatch = event.target.closest('.card-swatches__swatch');
      if (!swatch) return;

      // Ignore moves between swatches inside the same row
      const to = event.relatedTarget;
      if (to && to.closest && to.closest('.card-swatches') === swatch.closest('.card-swatches')) return;

      const card = cardOf(swatch);
      if (!card) return;

      const img = findCardImage(card);
      if (!img || img.dataset.swatchOriginalSrc == null) return;

      const { swatchOriginalSrc, swatchOriginalSrcset, swatchOriginalSizes } = img.dataset;
      if (swatchOriginalSrc) img.setAttribute('src', swatchOriginalSrc);
      if (swatchOriginalSrcset) img.setAttribute('srcset', swatchOriginalSrcset);
      else img.removeAttribute('srcset');
      if (swatchOriginalSizes) img.setAttribute('sizes', swatchOriginalSizes);
      else img.removeAttribute('sizes');
    },
    { passive: true }
  );
})();
